module.exports = __webpack_public_path__ + "media/admin/cs_publication_001_sm-0ae152b3.png";